import Splitting from "splitting";
import { theme } from "../App";

const splitText = (element) => {
  if (element) {
    const strongElements = Array.from(element.childNodes)
      .filter((node) => node.tagName === "STRONG")
      .map((node) => node.textContent);

    const res = Splitting({
      target: element,
      by: "lines",
    });

    const initialDelay = theme.headingFadeInDelayInMs;

    res.forEach((splitResult) => {
      const delayValue = 600 / splitResult.lines.length;
      let delay = -delayValue;

      const wrappedLines = splitResult.lines
        .map((wordsArr) => {
          delay = delay + delayValue;
          return `
      <span class="splitting-line">
        ${wordsArr
          .map((word) => {
            const currentWord = word.innerHTML;
            let formatedWord = strongElements.includes(currentWord)
              ? `<strong>${strongElements.find(
                  (w) => w === currentWord
                )}</strong>`
              : currentWord;
            return `<span class="word" style="animation-delay: ${
              initialDelay + delay
            }ms">${formatedWord}</span><span class="whitespace"> 
       </span>`;
          })
          .join("")}
      </span>`;
        })
        .join("");
      splitResult.el.innerHTML = wrappedLines;
    });
  }
};

export default splitText;
